module.exports = __webpack_public_path__ + "img/logo_kruisbergsetuin.6c796a8a.png";